import { FooterState } from '../interfaces/interface';

type WithFooterState = {
  FooterSlice: FooterState;
};
export const FooterStateSelector = (state: WithFooterState): FooterState =>
  state.FooterSlice;
